import React, { useState } from "react";


const AboutLonavalley = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const faqs = [
        {
            question: "What is Lonavalley?",
            answer:
                "Lonavalley is a premium gated Resort NA plotting project located near Lonavala, in the Kamshet valley region. The project is spread across 125 acres and offers large 10,000 sq. ft. Proposed Resort NA plots, surrounded by valleys, waterfalls and natural landscapes. It is designed for buyers looking at a second home, farmhouse-style living and long-term land ownership",
        },
        {
            question: "Where is Lonavalley located?",
            answer:
                "Lonavalley is located in the Khandshi–Nesave area of Kamshet valley, in the Lonavala region of Maharashtra. The project is situated near Shirota Dam, with connectivity towards Lonavala, Pune and Mumbai.",
        },
        {
            question: "Where is Lonavalley Kamshet?",
            answer:
                "Lonavalley is situated in Khandshi–Nesave, in the Kamshet valley near Lonavala. It is located close to important natural landmarks such as Shirota Dam, Uksan Dam and the Indrayani River region.",
        },
        {
            question: "How far is Lonavalley from Lonavala?",
            answer:
                "Lonavalley is located approximately 30 minutes from Lonavala town by road.",
        },
        {
            question: "How far is Lonavalley from Pune?",
            answer:
                "Lonavalley is approximately 45–60 minutes from Pune by road.",
        },
        {
            question: "How far is Lonavalley from Mumbai?",
            answer:
                "Lonavalley is approximately 1.5–2 hours from Mumbai ,Lonavalley is well connected to Mumbai, making it a convenient destination for those seeking a peaceful weekend getaway and a nature-inspired second-home lifestyle away from the city.",
        },
        {
            question: "How many acres is Lonavalley?",
            answer:
                "Lonavalley is a 125-acre gated community project. The project also includes a dedicated resort and amenity area as part of its planned development.",
        },
        {
            question: "Who is developing Lonavalley?",
            answer:
                "Lonavalley is developed by Samriddhi Group Builders & developers ,Samriddhi Group as the developer and presents the project as part of its premium real estate and land development portfolio.",
        },
        {
            question: "Is Lonavalley a resort project?",
            answer:
                "Lonavalley is a Resort NA plotting project where customers can own a piece of land and create their dream farmhouse or bungalow in a premium, nature-led environment.Beyond personal use, depending on the applicable permissions and development model, owners can also explore commercial opportunities such as renting out their bungalow as a holiday home or developing it for hospitality-oriented use. Lonavalley combines land ownership with a resort-style living experience, offering a destination designed around nature, leisure, lifestyle and resort amenities making it suitable for those looking for a personal getaway as well as potential income-generating opportunities.",
        },
        {
            question: "What is the plot size?",
            answer:
                "Lonavalley offers Proposed Resort NA plots of 10,000 sq. ft. each, with possession of 9,000 sq. ft. The plots are designed to offer ample space for a spacious farmhouse, bungalow or second-home development.",
        },

        {
            question: "What is the price of Lonavalley plots?",
            answer:
                "an introductory pre-launch price of ₹650 per sq. ft., with a total price of ₹65 lakhs for a 10,000 sq. ft. plot. The website also mentions an official launch price of ₹750 per sq. ft. Please note: Pricing and offers may change, so customers should always confirm the latest price directly with the Lonavalley sales team.",
        },
        {
            question: "Is the project sanctioned?",
            answer:
                "Lonavalley is a PMRDA-sanctioned project.Pune Metropolitan Region Development Authority (PMRDA)",
        },
        {
            question: "What documents are available?",
            answer:
                "Customers can review the relevant project and property documents, including the Individual Sale Deed and 7/12 extract, as applicable. Our team can guide you through the available documentation during the booking and due-diligence process.",
        },
        {
            question: "What is the possession status?",
            answer:
                "Lonavalley offers 10,000 sq. ft. Proposed Resort NA plots with possession of 9,000 sq. ft.",
        },
        {
            question: "How to reach Lonavalley?",
            answer:
                "Lonavalley is conveniently accessible by road from Mumbai and Pune.The project is located in the Khandshi–Nesave area of Kamshet Valley,Visitors can reach the project via the Mumbai–Pune Expressway/Old Mumbai–Pune Highway, depending on their starting location and preferred route.",
        },
        {
            question: "What is the distance from Lonavala to Lonavalley?",
            answer:
                "Lonavalley is approximately 30–31 km from Lonavala, depending on the route taken. Travel time is generally around 45–60 minutes,",
        },
        {
            question: "How far is Lonavalley from Pune?",
            answer:
                "Lonavalley is approximately 60 km from Pune, depending on the starting point and route.",
        },
        {
            question: "How far is Lonavalley from Mumbai?",
            answer:
                "Lonavalley is approximately 2–3 hours from Mumbai, depending on the starting point and route.",
        },

        {
            question: "What is the nearest railway station to Lonavalley?",
            answer:
                "Kamshet Railway Station is one of the nearest and most convenient railway stations.",
        },

    ];

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="about-lonavalley" id="about-lonavalley">
            <div className="about-container">

                {/* Section Header */}
                <div className="about-header" id="faq">
                    <span className="section-kicker">
                        ABOUT LONAVALLEY
                    </span>

                    <h2>
                        Everything You Need to Know
                        <span> About Lonavalley</span>
                    </h2>

                    <p>
                        Explore frequently asked questions about Lonavalley,
                        its location, connectivity, Resort NA Farmhouse Plots
                        and the lifestyle it offers.
                    </p>
                </div>

                {/* FAQ Accordion */}
                <div className="faq-list">
                    {faqs.map((faq, index) => (
                        <div
                            className={`faq-item ${activeIndex === index ? "active" : ""
                                }`}
                            key={index}
                        >
                            <button
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                                aria-expanded={activeIndex === index}
                            >
                                <span>{faq.question}</span>

                                <span className="faq-icon">
                                    {activeIndex === index ? "−" : "+"}
                                </span>
                            </button>

                            <div className="faq-answer-wrapper">
                                <div className="faq-answer">
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* CTA */}
                <div className="about-cta">
                    <p>
                        Still have questions about Lonavalley?
                    </p>

                    <a href="#contact">
                        Talk to Our Team
                        <span>→</span>
                    </a>
                </div>

            </div>
        </section>
    );
};

export default AboutLonavalley;